<template>
    <template v-if="!$store.state.waitingRequest">
        <transition name="zoom">
            <div class="scroll-btn" alt="Haut de page" @click="scrollTop" v-if="scrollAmount > 100"><i class="fas fa-angle-double-up"></i></div>
        </transition>
        
        <main>
            <h1>Jeux en ligne gratuits</h1>
            <div class="popular-games">
                <h3>Jeux tendances <label class="fa-fire-alt">🔥</label></h3>
                <div class="right-container">
                    <div class="right-slide">
                        <div class="right-block">
                            <router-link :to="'/' + unJeu.title_url" :title="unJeu.title" v-for="unJeu in popularGames" :key="unJeu.id" class="game">
                                <p>{{ truncateTitle(unJeu.title) }}</p>
                                <div class="game-num">#{{ unJeu.num }}</div>
                                <div class="background" :style="{'background-image' : 'url(\'static/miniatures/' + unJeu.image_url + '\')'}"></div>
                            </router-link>
                        </div>
                        <div class="right-block">
                            <router-link :to="'/' + unJeu.title_url" :title="unJeu.title" v-for="unJeu in popularGames" :key="unJeu.id" class="game">
                                <p>{{ truncateTitle(unJeu.title) }}</p>
                                <div class="game-num">#{{ unJeu.num }}</div>
                                <div class="background" :style="{'background-image' : 'url(\'static/miniatures/' + unJeu.image_url + '\')'}"></div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <section class="home">
                <div class="left-games">
                    <h2>Notre sélection <label class="fa-heart">❤️</label></h2>
                    <Slider />
                    
                    <div class="featured-games">
                        <div class="games-container">
                            <div class="jeu-container" v-for="unJeu in featuredGames" :key="unJeu.id">
                                <div class="jeu">
                                    <div class="ribbon-top-container">
                                        <div class="ribbon-top">TOP</div>
                                    </div>

                                    <router-link :to="'/' + unJeu.title_url" :title="unJeu.title">
                                        <div class="img"><div class="background" :style="{'background-image' : 'url(\'static/miniatures/' + unJeu.image_url + '\')'}"></div></div>
                                        <div class="contenu">
                                            <p>{{ unJeu.title }}</p>
                                            <span>Joué {{ unJeu.view_count }} fois</span>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="clickers-games">
                        <div class="title-btn">
                            <h2>Pour cliquer à l'infini... <label class="fa-mouse">🖱️</label></h2>
                            <router-link to="/categorie/clickers" class="more">Voir +</router-link>
                        </div>
                        <div class="games-container">
                            <div class="jeu-container" v-for="unJeu in clickersGames" :key="unJeu.id">
                                <div class="jeu">
                                    <div class="ribbon-new-container" v-if="(((nowDate - (new Date(unJeu.created_at.replace(/-/g, '/')).getTime()/1000))/3600).toFixed(2)) <= 72.00">
                                        <div class="ribbon-new">NOUVEAU</div>
                                    </div>
                                    
                                    <router-link :to="'/' + unJeu.title_url" :title="unJeu.title">
                                        <div class="img"><div class="background" :style="{'background-image' : 'url(\'static/miniatures/' + unJeu.image_url + '\')'}"></div></div>
                                        <div class="contenu">
                                            <p>{{ unJeu.title }}</p>
                                            <span>Joué {{ unJeu.view_count }} fois</span>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ad-banner">
                        <ins class="adsbygoogle"
                        data-ad-client="ca-pub-2512331316053279"
                        data-ad-slot="6346220535"></ins>
                    </div>
                </div>
                <div class="right-games">
                    <div class="random-games">
                        <h2>Découvre maintenant <label class="fa-compass">🧭</label></h2>
                        
                        <div class="games-container">
                            <div class="jeu-container" v-for="unJeu in randomGames" :key="unJeu.id">
                                <div class="jeu">
                                    <div class="ribbon-new-container" v-if="(((nowDate - (new Date(unJeu.created_at.replace(/-/g, '/')).getTime()/1000))/3600).toFixed(2)) <= 72.00">
                                        <div class="ribbon-new">NOUVEAU</div>
                                    </div>

                                    <router-link :to="'/' + unJeu.title_url" :title="unJeu.title">
                                        <div class="img"><div class="background" :style="{'background-image' : 'url(\'static/miniatures/' + unJeu.image_url + '\')'}"></div></div>
                                        <div class="contenu">
                                            <p>{{ unJeu.title }}</p>
                                            <span>Joué {{ unJeu.view_count }} fois</span>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="new-games">
                        <h2>Nouveaux jeux <label class="fa-fire">⚡</label></h2>
                        <div class="games-container">
                            <div class="jeu-container" v-for="unJeu in newGames" :key="unJeu.id">
                                <div class="jeu">
                                    <div class="ribbon-new-container" v-if="(((nowDate - (new Date(unJeu.created_at.replace(/-/g, '/')).getTime()/1000))/3600).toFixed(2)) <= 72.00">
                                        <div class="ribbon-new">NOUVEAU</div>
                                    </div>
                                    
                                    <router-link :to="'/' + unJeu.title_url" :title="unJeu.title">
                                        <div class="img"><div class="background" :style="{'background-image' : 'url(\'static/miniatures/' + unJeu.image_url + '\')'}"></div></div>
                                        <div class="contenu">
                                            <p>{{ unJeu.title }}</p>
                                            <span>Joué {{ unJeu.view_count }} fois</span>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <GamesFeed />
                </div>
            </section>
            
            <div class="about">
                <h3>À propos de <strong>Games™</strong> par <strong>ClickTestCPS.fr</strong></h3>

                <p>Découvre une sélection de plusieurs centaines de <strong>jeux en ligne gratuits</strong>. Mets à profit ta capacité à cliquer rapidement avec nos <router-link to="/categorie/clickers">Jeux de Clickers</router-link>. Défie ton cerveau grâce à de superbes <router-link to="/categorie/reflexion">Jeux de Réflexion</router-link>. Déchaîne-toi en t'amusant en jouant à nos <router-link to="/categorie/action">Jeux d'Action</router-link> ! Enfin, prends le contrôle du bitume à travers nos <router-link to="/categorie/course">Jeux de Course</router-link> forts en sensation. Découvre nos catégories en <router-link to="/categories">cliquant ici</router-link>.</p>
                
                <p>Nous ajoutons quotidiennement de nouveaux jeux pour te permettre de te divertir sans limites. Défie tes amis et des milliers de joueurs en ligne chaque mois. Tu peux être sûr(e) que nous te proposons ici les meilleurs jeux du net !</p>
            </div>

            <div class="ad-banner">
                <ins class="adsbygoogle"
                data-ad-client="ca-pub-2512331316053279"
                data-ad-slot="6346220535"></ins>
                <div class="background">PUBLICITÉ</div>
            </div>
            
        </main>
    </template>
    <template v-else>
        <SkeletonHome />
    </template>
</template>

<script>
import Slider from '../components/Slider.vue';
import GamesFeed from '../components/GamesFeed.vue';
import SkeletonHome from '../components/SkeletonHome.vue';
import AddGoogleScripts from '../mixins/addGoogleScripts';

export default {
    name: 'Home',
    mixins: [AddGoogleScripts],
    components: {
        Slider, GamesFeed, SkeletonHome
    },
    data() {
        return {
            nowDate: null,

            nbRequests: 0,

            featuredGames: [],
            popularGames: [],
            randomGames: [],
            newGames: [],
            clickersGames: [],

            formData: null,
            scrollAmount: 0,
            
            metas : {
                title: 'Jeux en ligne gratuits en un clic - Jeu FR '+new Date().getFullYear()+' sans inscription - Games™ par ClickTestCPS',
                meta: [
                    {
                        name: 'description',
                        content: 'Jouez à des centaines de jeux en ligne sur Games™ par ClickTestCPS.fr ! Une sélection unique de jeux en ligne gratuits alimentée quotidiennement. Jeux de Clickers, Jeux d’Action, Jeux de Réflexion ou encore Jeux de Course, vous pouvez être sûr que vous trouverez votre bonheur ici.'
                    },
                    {
                        name: 'keywords',
                        content: 'ClickTestCPS.fr games, ClickTestCPS games, Jeux clicktestcps, jeux en ligne, jeux en ligne gratuit, jeux en ligne entre amis, jeux en ligne multijoueur, jeux en ligne pc, jeux en ligne jeu, jeu en ligne, jeux à deux en ligne, jeux en ligne fille, jeux en ligne cp, jeux en ligne switch, rocket league en ligne, nouveaux jeux en ligne '+new Date().getFullYear()+', jeu en ligne à plusieurs, action ou vérité jeu en ligne, jeu en ligne maternelle, jeu en ligne adulte, jeu en ligne 6 ans, site de jeu en ligne, jeux. fr, jeux .fr, jeu en ligne mario, jeu en ligne mac, jeu en ligne téléphone, jeu en ligne de voiture, jeu en ligne de clic, jeu en ligne de clique, jeu en ligne ce2, jeu à boire en ligne, jeu en ligne 3000, où est charlie jeu en ligne, jeu en ligne io, jeu en ligne bebe, jeu en ligne foot '+new Date().getFullYear()+', jeu en ligne cheval, jeu en ligne escape game, jeu en ligne youtube, jeu en ligne influenceurs, jeu en ligne uno, jeu en ligne streamers, jeu en ligne vidéo, jeu en ligne simulation, jeu en ligne multiplication, jeu en ligne fdj, jeu en ligne sur pc, jeux en ligne sur pc, online games, online free games, online free games without login, jeu en ligne guerre, jeu en ligne iphone, jeu en ligne question pour un champion, jeu en ligne battle royale, jeu en ligne rpg, jeu en ligne minecraft, jeu en ligne kohi, jeu en ligne fps, jeu en ligne rapide, jeu en ligne et gratuit, jeu online, jeu avec chat en ligne, jeu en ligne loup garou, jeu en ligne quizz, jeu de quizz, jeu en ligne couple, jeu en ligne culture générale, jeu en ligne barbie, jeu en ligne français'
                    },
                    {
                        property: 'og:image',
                        content: 'https://clicktestcps.fr/og-games.png'
                    },
                    {
                        property: 'og:title',
                        content: 'Jeux en ligne gratuits en un clic - Jeu FR '+new Date().getFullYear()+' sans inscription - Games™ par ClickTestCPS'
                    },
                    {
                        property: 'og:description',
                        content: 'Jouez à des centaines de jeux en ligne gratuitement et sans inscription. Une sélection unique de jeux en ligne gratuits alimentée quotidiennement'
                    }
                ]
            }
        }
    },
    mounted() {
        useHead(this.metas);

        this.$store.commit('setRequestTrue');
        
        this.formData = new FormData();
        this.formData.append('data', JSON.stringify({post: "1"}));
        
        this.getFeaturedGames();

        window.addEventListener('scroll', s => { this.scrollAmount = window.scrollY });

        this.nowDate = new Date().getTime()/1000;
    },
    methods: {
        getFeaturedGames() {
            axios
            .post(this.$store.state.apiUrl+"?request=getFeaturedGames", this.formData)
            .then((response) => {
                if(response.data.length > 0) {
                    this.featuredGames = response.data;
                    this.getMostPopularGames();
                    this.getRandomGames();
                    this.getNewGames();
                    this.getClickersGames();
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        },
        getMostPopularGames() {
            axios.post(this.$store.state.apiUrl+"?request=getMostPopularGames", this.formData)
            .then((response) => {
                if(response.data.length > 0) {
                    this.popularGames = response.data;
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        },
        getRandomGames() {
            axios
            .post(
            this.$store.state.apiUrl+"?request=getRandomGames", this.formData
            )
            .then((response) => {
                if(response.data.length > 0) {
                    this.randomGames = response.data;
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        },
        getNewGames() {
            axios
            .post(
            this.$store.state.apiUrl+"?request=getNewGames", this.formData
            )
            .then((response) => {
                if(response.data.length > 0) {
                    this.newGames = response.data;
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        },
        getClickersGames() {
            axios
            .post(
            this.$store.state.apiUrl+"?request=getClickersGames", this.formData
            )
            .then((response) => {
                if(response.data.length > 0) {
                    this.clickersGames = response.data;
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        },
        scrollTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        truncateTitle(value) {
            return value && value.length > 23 ? value.slice(0,23).split(' ').slice(0, -1).join(' ').concat('...') : value;
        }
    },
    watch: {
        nbRequests() {
            if(this.nbRequests == 5) {
                this.$store.commit('setRequestFalse');
            }
        }
    }
}
</script>

<style scoped src="@/assets/home.css">
</style>